<form class="contract d-flex direction-column align-center"
      [formGroup]="contractForm"
  >
  <div
    class="contract-header header d-flex align-center justify-space-between"
    [ngClass]="{
      'header-invoice-grid': currentContext === 'invoice',
      'header-transfer-grid': currentContext !== 'invoice'
    }">

    <div class="header-text" style="text-align:left;width:20px;display:none">
      {{linha}}
    </div>

    <div *ngIf="currentContext === 'invoice'" class="header-checkbox-column">
      <app-c-checkbox class="header-contract-checkbox"
                      [label]="''"
                      [id]="contract.ContractId"
                      [contractNumberInput]="false"
                      [checked]="checkedControl"
                      (change)="checkUncheckContract(contract)"></app-c-checkbox>
    </div>

    <div class="header-cell header-cell-contract flex-1">
      <span class="header-mobile-label">
        Contrato
      </span>
      <span class="header-contract-number-row">
        <span class="header-text header-text-strong header-text-left">
          {{ contract.Number || '-' }}
        </span>
        <span *ngIf="contract.Version !== null && contract.Version !== undefined"
              class="header-version-tag">
          v{{ contract.Version }}
        </span>
      </span>

      <span class="header-subtext" matTooltip="Consulta: {{ contract.QueryNumber || '-' }}">
        {{ contract.QueryNumber || '-' }}
      </span>

      <span class="header-subtext header-subtext-truncate" matTooltip="Status Contrato: {{ formatStatusText(contract.StatusOverride) }}">
        <app-status-badge
          [label]="formatStatusText(contract.StatusOverride) | titlecase"
          [tone]="getContractStatusTone()"
          variant="outline"
          size="sm">
        </app-status-badge>
      </span>

      <span class="header-status-tags-row">
        <span *ngIf="isContractInactive()"
              class="header-status-tag inactive">
          Inativo
        </span>
        <span *ngIf="getContractReverseBadgeLabel() as reverseBadgeLabel"
              class="header-status-tag inactive">
          {{ reverseBadgeLabel }}
        </span>
      </span>
      
    </div>

    <div class="header-cell header-cell-date flex-1">
      <span class="header-mobile-label">
        Data
      </span>
      <span class="header-text header-text-strong">
        {{ (contract.ContractDate | date : "dd/MM/yyyy") || "-" }}
      </span>
    </div>

    <div class="header-cell header-cell-product flex-1">
      <span class="header-mobile-label">
        Produto
      </span>
      <span class="header-text header-text-strong header-subtext-truncate"
            [matTooltip]="getContractProductLabel()">
        {{ getContractProductLabel() }}
      </span>
    </div>

    <div class="header-cell flex-1">
      <span class="header-mobile-label">
        Banco
      </span>
      <span class="header-text header-text-strong">
        {{ (contract.FinancialInstitution | titlecase) || '-' }}
      </span>
      <span class="header-subtext" matTooltip="BPO/Regional: {{ contract.Bpo || '-' }}">
        {{ contract.Bpo || '-' }}
      </span>
    </div>

    <div class="header-cell header-cell-client flex-2">
      <span class="header-mobile-label">
        Cliente
      </span>
      <span class="header-text header-text-strong">
        {{ (contract.Client | titlecase) || '-' }}
      </span>
      <span class="header-subtext">
        CPF: {{ contract.ClientDocument || '-' }}
      </span>
    </div>

    <div class="header-cell header-cell-client flex-2">
      <span class="header-mobile-label">
        Parceiro
      </span>

      <span class="header-text header-text-strong header-subtext-truncate"
            [matTooltip]="getPartnerName()">
        {{ (getPartnerName() | titlecase) || '-' }}
      </span>
      <span class="header-subtext">
        {{ getPartnerDocument() || '-' }}
      </span>

      <span class="header-subtext" matTooltip="Operação: {{ contract.OperationType || '-' }} - Canal: {{ contract.Chanel || '-' }}">
        {{ contract.OperationType || '-' }} - Canal: {{ contract.Chanel || '-' }}
      </span>
    </div>

    <div class="header-cell header-cell-client flex-1"
         [ngClass]="{ 'text-danger': contract.IsToReverseOrReversed }">
      <span class="header-mobile-label">
        Valor
      </span>
      <span class="header-text header-text">
        {{ contract.Amount ? (contract.Amount | currency : "BRL") : '-' }}
        
      </span>
      <!-- <span class="header-subtext">
        Fat: {{ contract.ComissionAmount | currency: "BRL" }}
      </span>
      <span class="header-subtext">
        Rep: {{ getTransferAmount() | currency: "BRL" }}
      </span> -->
    </div>

    <div class="header-cell header-cell-fat flex-1">
      <span class="header-mobile-label">
        Faturamento
      </span>
      <span class="header-invoicing-pill"
            [ngClass]="getInvoicingStatusClass()">
        <span>{{ getInvoicingStatusLabel() }}</span>
      </span>
      <span class="header-subtext header-lot-lines">
        <span class="header-lot-line" matTooltip="Lote Faturamento: {{ getInvoiceBatchNumber() || '-' }}">
          <span class="header-lot-value">{{ getInvoiceBatchNumber() || '-' }}</span>
        </span>
        <span class="header-subtext" matTooltip="Valor Comissão: {{ contract.ComissionAmount | currency : 'BRL' }}">
          {{ contract.ComissionAmount | currency: "BRL" }}
      </span>
      </span>
    </div>

    <div class="header-cell header-cell-fat flex-1">
      <span class="header-mobile-label">
        Repasse
      </span>
      <span class="header-invoicing-pill"
            [ngClass]="getTransferStatusClass()">
        <span>{{ getTransferStatusLabel() }}</span>
      </span>
      <span class="header-subtext header-lot-lines">
        <span class="header-lot-line" matTooltip="Lote Repasse: {{ getTransferBatchDisplayNumber() || '-' }}">
          <span class="header-lot-value">{{ getTransferBatchDisplayNumber() || '-' }}</span>
        </span>
        <span class="header-subtext" matTooltip="Valor Repasse: {{ getTransferAmount() | currency : 'BRL' }}">
          {{ getTransferAmount() | currency: "BRL" }}
      </span>
      </span>
    </div>

    <div class="header-actions d-flex align-center justify-flex-end">
      <span *ngIf="contract.Error"
            class="header-error"
            [matTooltip]="getErrorTooltip()">
        <app-svg-icon src="assets/icons/warning-icon.svg"
                      alt="expand"
                      width="22px"
                      [color]="isWarningError() ? 'warn' : 'dangerRed'"
                      [attr.color]="isWarningError() ? 'warn' : 'dangerRed'"></app-svg-icon>
      </span>
      <button *ngIf="contract.StageName !== 'Aprovacao'"
              type="button"
              class="header-edit-btn edit-btn"
              (click)="navigateToContractEdit(contract)">
        <app-svg-icon class="edit-btn-svg"
                      src="assets/icons/edit-icon.svg"
                      width="13px"
                      height="16px"
                      color="white"></app-svg-icon>
      </button>
      <button *ngIf="contract.StageName === 'Aprovacao'"
              type="button"
              class="header-edit-btn edit-btn"
              [routerLink]="['/aprovacao', contract.Number, contract.QueryNumber, contract.FinancialInstitution]"
              [queryParams]="{ byId: false }">
        <app-svg-icon class="edit-btn-svg"
                      src="assets/icons/edit-icon.svg"
                      width="14px"
                      height="16px"
                      color="white"></app-svg-icon>
      </button>
    </div>

  </div>
</form>
